/** Extract Vimeo embed ID from any Vimeo URL or raw ID */
export function parseVimeoInput(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) return "";

  // Full URL: https://vimeo.com/1166230742/821214c047?share=copy...
  const vimeoUrlMatch = trimmed.match(
    /vimeo\.com\/(\d+)\/([a-f0-9]+)/i
  );
  if (vimeoUrlMatch) return `${vimeoUrlMatch[1]}?h=${vimeoUrlMatch[2]}`;

  // Player embed URL: https://player.vimeo.com/video/1166230742?h=821214c047
  const playerMatch = trimmed.match(
    /player\.vimeo\.com\/video\/(\d+)\?h=([a-f0-9]+)/i
  );
  if (playerMatch) return `${playerMatch[1]}?h=${playerMatch[2]}`;

  // Plain vimeo.com/ID (public video, no hash)
  const plainMatch = trimmed.match(/vimeo\.com\/(\d+)(?:\?|$)/);
  if (plainMatch) return plainMatch[1];

  // Raw numeric ID (with optional ?h= hash) — pass through
  if (/^\d+(\?h=[a-f0-9]+)?$/i.test(trimmed)) return trimmed;

  return "";
}
